import React from 'react';

import { FaSearchengin } from 'react-icons/fa';
import { MdWeb } from 'react-icons/md';
import { AiOutlineCloudUpload, AiOutlineMail } from 'react-icons/ai';
import { BiSupport, BiDollar, BiBookContent } from 'react-icons/bi';
import { TiSocialAtCircular } from "react-icons/ti";
const iconStyle = (Icon) => <Icon size="3rem" color="#0f0f0f" />;

export const featuresData = [
	{
		name: 'SEO',
		description: 'Having a great website is not enough. We make sure ready-to-buy consumers find you when they search online.',
		icon: iconStyle(FaSearchengin),
		imgClass: 'one',
	},
	{
		name: 'WEB DESIGN',
		description: 'Turn consumers into customers with a high performing website.',
		icon: iconStyle(MdWeb),
		imgClass: 'two',
	},
	{
		name: 'SOCIAL MEDIA',
		description: 'Connect with your audience in their preferred channels.',
		icon: iconStyle(TiSocialAtCircular),
		imgClass: 'three',
	},
	{
		name: 'PAY-PER-CLICK',
		description: 'Get immediate results with an effective pay-per-click campaign.',
		icon: iconStyle(BiDollar),
		imgClass: 'four',
	},
	{
		name: 'EMAIL MARKETING',
		description: 'Nurture leads, engage your customers, and improve conversions with a cost-effective email marketing strategy.',
		icon: iconStyle(AiOutlineMail),
		imgClass: 'five',
	},
	{
		name: 'CONTENT WRITING',
		description:
			'Engage your audience with content that connects and keeps them returning for more.',
		icon: iconStyle(BiBookContent),
		imgClass: 'six',
	},
];
